import React, { useEffect } from "react";
import {
  ViedocButtonElement,
  ViedocDialogElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as documentActions from "../../../../store/actions/documentActions";
import * as templateActions from "../../../../store/actions/templateActions";

const DeleteDocumentPopUp = ({
  deletePayload,
  setShowDocDeletePopup,
  sectionOrigid,
  setIsDeletePopUpVisible,
  origiartifactid,
  fromTo,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    document
      .getElementById("doc-delete")
      .addEventListener("dialog-hide", (e) => {
        e.stopPropagation();
        fromTo === "Templates"
          ? setIsDeletePopUpVisible(false)
          : setShowDocDeletePopup(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const documentDeleteHandler = () => {
    if (fromTo === "Dropzone") {
      dispatch(templateActions.deleteDropZone(deletePayload));
      dispatch(documentActions.deleteAGGridDocument(deletePayload)); 
    } else if (fromTo === "Documents") {
      deletePayload.origiartifactid = origiartifactid;
      deletePayload.sectionOrigid = sectionOrigid;
      dispatch(documentActions.deleteAGGridDocument(deletePayload));
    } else if (fromTo === "Templates") {
      dispatch(templateActions.deleteTemplate(deletePayload));
    } else {
      deletePayload.origiartifactid = origiartifactid;
      deletePayload.sectionOrigid = sectionOrigid;
      dispatch(documentActions.deleteDocument(deletePayload));
    }
    document.getElementById("doc-delete")?.hide();
    document.getElementById("manage-template-view")?.hide();
    document.getElementById("doc-view-popup")?.hide();
  };

  const documentDeleteCancelhandler = (e) => {
    e.stopPropagation();
    document.getElementById("doc-delete")?.hide();
  };

  return (
    <ViedocDialogElement id="doc-delete" size="small" open preventCloseByClick>
      <header slot="header">
        <p className="f21">{t("DELETE_POPUP.CONFIRM_DELETE")}</p>
      </header>
      <main className="delete-document">
        <div className="delete-icon">
          <viedoc-icon name="delete_bin"></viedoc-icon>
        </div>
        <div className="delete-option">
          <label>{t("DELETE_POPUP.DELETE_DOC_CONFIRMATION")}</label>
          <div className="fileName">
            {deletePayload.fileName} {"?"}
          </div>
          <div className="pt-20">
            <ViedocButtonElement
              class="mr-10"
              variant="neutral"
              size="small"
              onClick={(e) => documentDeleteCancelhandler(e)}
              title={t("TMF.BUTTON_CANCELBTN")}
            >
              {t("TMF.BUTTON_CANCELBTN")}
            </ViedocButtonElement>
            <ViedocButtonElement
              class="mr-10"
              variant="error"
              size="small"
              onClick={() => documentDeleteHandler()}
              title={t("TMF.BUTTON_CONFIRM")}
            >
              {t("TMF.BUTTON_CONFIRM")}
            </ViedocButtonElement>
          </div>
        </div>
      </main>
    </ViedocDialogElement>
  );
};

export default DeleteDocumentPopUp;
